<template>
  <div class="relative z-10 flex desk:mt-12 mobOnly:mb-20">
    <div
      class="flex items-center"
    >
      <div v-for="(breadcrumb, index) in breadcrumbs" :key="breadcrumb.norceCode">
        <component
          :is="$sbLinkCheck(breadcrumb.link) ? NuxtLink : 'div'"
          :to="$sbLinkFix(breadcrumb.link)"
          :target="$sbLinkTarget(breadcrumb.link)"
          class="type-tagline-xs text-text-subtle"
        >
          <span
            :class="{
              'mobOnly:underline': $sbLinkCheck(breadcrumb.link)
            }"
          >{{ breadcrumb.linkTitle }}</span>
          <span
            v-if="index + 1 < breadcrumbs.length"
            class="inline-block px-8"
          >/</span>
        </component>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ProductModel } from '#models/product';
import { useGlobalContentStore } from '~/store/globalContent';
import { CategoryLink } from '#constants/types/storyblok';
import { Category } from '#constants/types/algolia';

const NuxtLink = resolveComponent('NuxtLink');
const globalContent = useGlobalContentStore();
const { $t } = useNuxtApp();

const props = defineProps<{
  productItem: ProductModel,
}>();

const breadcrumbs = computed(()=> {
  type ThisBreadcrumbs = CategoryLink & { linkTitle: string }
  /* If we want "all products" as the first step
  const output = [{
    norceCode: '',
    linkTitle: $t('pdp.breadcrumbs.allProducts'),
    link: globalContent.config?.allProductsPage,
  }] as ThisBreadcrumbs[];*/
  const output = [] as ThisBreadcrumbs[];
  const tree = [] as Category[];

  const topLevel = props.productItem.categories.find(f => f.parentCode === null);
  if (topLevel) {
    tree.push(topLevel);
    let searchNext = topLevel.code;
    while (true) {
      const child = props.productItem.categories.find(f => f.parentCode === searchNext);
      if (!child) {
        break;
      }
      tree.push(child);
      searchNext = child.code;
    }
  }

  tree.forEach(category => {
    const link = globalContent.config?.categoryMapping.find(f => f.norceCode === category.code);

    if (link) {
      output.push({
        ...link,
        linkTitle: category.name,
      });
    }
  });

  return output;
});

</script>